import { Box } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './styles.css';

const NutriInfoForm = () => {
  function handleAngendar() {
    window.location.href = '#/homepage/saude/agendamento-nutricionista';
  }

  return (
    <section id="nutriInfo">
      <p className="body-title mt-4">Serviço:</p>
      <p
        className="h4 mt-4"
        style={{ color: '#838383', width: '100%', marginBottom: 20 }}
      >
        Novidades no programa Mais Vida Ativa: a partir de segunda-feira
        (24/03/2025), os atendimentos com nutricionista e psicólogo estão de
        volta! E com uma novidade: agora, os serviços serão cobertos pelos
        planos de saúde das Casas e, além disso, parte da coparticipação será
        devolvida na Plataforma Sindilegis Mais como cashback. <br />
        O serviço estará disponível para filiados cobertos por planos
        conveniados. Ao apresentar a carteirinha do plano de saúde no momento do
        atendimento, parte do valor da coparticipação será devolvida na sua
        carteira do Mais em até 90 dias, proporcionando cada vez mais vantagens
        e economia aos filiados. <br />
        <br />
        <strong> Quem pode utilizar o benefício? </strong>
        <br />
        O serviço está disponível exclusivamente para filiados e seus
        dependentes cadastrados em um dos planos de saúde atendidos. <br />
        <br />
        <strong>Como utilizar?</strong> <br />
        Para utilizar o serviço, basta ser filiado ao Sindilegis, estar em um
        dos planos conveniados e apresentar a carteirinha do plano de saúde no
        momento do atendimento.
        <br />
        <br />
        <strong>Como funciona o reembolso?</strong> <br />
        Os filiados que utilizarem o serviço receberão 50% do percentual pago na
        coparticipação do plano. Ou seja: se você precisa pagar 30% do valor
        total do benefício, receberá metade dessa quantia de volta na carteira
        do Sindilegis Mais!
        <br />
        <br />
        <strong>Mais informações e agendamentos:</strong> <br />
        <strong>
          {' '}
          Se quiser saber mais detalhes ou marcar a sua consulta, entre em
          contato com o time de Benefícios e Eventos pelo telefone (61)
          3214-7300, opção 2 ou pelo whatsapp no mesmo número.
        </strong>{' '}
        <br />
        <br />
        <strong>Quais os planos conveniados?</strong> <br />
        AFEB BRASAL | AFFEGO | ANAFE SAÚDE | ASETE (ASTE) | CAESAN | CARE PLUS |
        CASEC (CODEVASF) | CASEMBRAPA (EMBRAPA) | CEAM BRASIL | CNTI | CONAB |
        FAPES (BNDES) | FASCAL|DF SAÚDE | LIFE EMPRESARIAL | OMINT SAÚDE | PF
        SAÚDE (Polícia Federal) | PLAN ASSISTE (MPU) | PLAS/JMU (STM) | PMDF
        (Polícia Militar do Distrito Federal) | POSTAL SAÚDE (ECT) | PROASA |
        PRÓ-SAÚDE (Câmara dos Deputados) | PRÓ-SAÚDE (TJDFT) | PRÓ-SOCIAL (TRF)
        | REAL GRANDEZA (demais planos, Salvus e Salutem) | SAÚDE CAIXA |
        SERPRO| SIS SENADO | STF-MED (STF) | TRE SAÚDE | TRT SAÚDE | TST SAÚDE |
        UNAFISCO (SINDIFISCO)
        <br />
        <br />
        <strong>Endereço: </strong>
        <br />
        SGAS 610, Conjunto C, Módulo 70 - Asa Sul, Brasília - DF, 70200-001.
      </p>
      <Box display="flex" justifyContent="center">
        <button
          className="mt-5"
          style={{
            backgroundColor: '#378587',
            padding: '16px 48px',
            color: '#fff',
            marginBottom: 20,
          }}
          onClick={() => handleAngendar()}
        >
          Agendar
        </button>
      </Box>
    </section>
  );
};

const mapStateToProps = () => {};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NutriInfoForm);
